(function () {
  const HINT_CLASS = 'armonia-pilot-route-hint';
  const ROUTE_ATTR = 'armonia_checkout_route';

  function forcedOpenpayFromDom() {
    return Boolean(
      document.querySelector(
        '[data-armonia-force-openpay="true"], [data-armonia-force-openpay="1"], input[data-armonia-force-openpay]'
      )
    );
  }

  function getPilotMode(items) {
    if (forcedOpenpayFromDom()) return 'openpay';
    const pilot = (items || []).filter((item) => {
      const pago = item.properties && item.properties._armonia_pago;
      return pago === 'contado' || pago === 'msi' || pago === 'openpay';
    });
    if (!pilot.length) return null;
    const modes = new Set(pilot.map((item) => item.properties._armonia_pago));
    if (modes.size > 1) return 'mixed';
    const pago = pilot[0].properties._armonia_pago;
    // Contado en producto solo-openpay → misma ruta OpenPay, sin UI de MSI/MP
    if (pago === 'contado' && forcedOpenpayFromDom()) return 'openpay';
    return pago;
  }

  /** openpay usa la misma ruta de checkout que contado (solo OpenPay). */
  function checkoutRouteForMode(mode) {
    if (mode === 'openpay') return 'contado';
    if (mode === 'contado' || mode === 'msi') return mode;
    return '';
  }

  function ensureRouteInputs(mode) {
    const forms = document.querySelectorAll('#cartDrawerForm, form#cart, form[action="/cart"]');
    const route = checkoutRouteForMode(mode);
    forms.forEach((form) => {
      let input = form.querySelector(`input[name="attributes[${ROUTE_ATTR}]"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `attributes[${ROUTE_ATTR}]`;
        form.appendChild(input);
      }
      input.value = route;
    });
  }

  function pilotExtraSelectors() {
    return [
      '.cart__whatsapp-button',
      '.cart-drawer__whatsapp-button',
      '.armonia-cart-msi-hint',
      '.cart__msi-hint',
      '.cart-drawer__msi-hint',
    ].join(', ');
  }

  function resetCtas(ctas) {
    const checkout = ctas.querySelector(
      '.cart__checkout-button, .cart-drawer__checkout-button'
    );
    const mp = ctas.querySelector(
      '.cart__mercado-pago-button, .cart-drawer__mercado-pago-button'
    );
    checkout?.classList.remove('armonia-pilot-hidden', 'armonia-pilot-primary');
    mp?.classList.remove('armonia-pilot-hidden', 'armonia-pilot-primary');
    const footer = ctas.closest('.cart__buttons, #cart-drawer-footer-buttons, .cart-drawer__buttons');
    const scope = footer || ctas.parentElement || document;
    footer
      ?.querySelectorAll(
        '.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons'
      )
      .forEach((el) => el.classList.remove('armonia-pilot-hidden'));
    scope.querySelectorAll(pilotExtraSelectors()).forEach((el) => {
      el.classList.remove('armonia-pilot-hidden');
    });
    footer?.querySelector('.' + HINT_CLASS)?.remove();
    ctas.parentNode?.querySelector('.' + HINT_CLASS)?.remove();
  }

  function applyRouteToCtas(ctas, mode) {
    if (!ctas) return;
    resetCtas(ctas);

    if (!mode) return;

    const checkout = ctas.querySelector(
      '.cart__checkout-button, .cart-drawer__checkout-button'
    );
    const mp = ctas.querySelector(
      '.cart__mercado-pago-button, .cart-drawer__mercado-pago-button'
    );
    const footer = ctas.closest('.cart__buttons, #cart-drawer-footer-buttons, .cart-drawer__buttons');
    const dynamic = footer?.querySelector(
      '.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons'
    );
    const scope = footer || ctas.parentElement || document;

    const hint = document.createElement('p');
    hint.className = HINT_CLASS + ' caption';
    hint.dataset.armoniaPilotMode = mode;
    ctas.parentNode?.insertBefore(hint, ctas);

    mp?.classList.add('armonia-pilot-hidden');
    dynamic?.classList.add('armonia-pilot-hidden');
    scope.querySelectorAll(pilotExtraSelectors()).forEach((el) => {
      el.classList.add('armonia-pilot-hidden');
    });
    checkout?.classList.remove('armonia-pilot-hidden');
    checkout?.classList.add('armonia-pilot-primary');

    if (mode === 'openpay') {
      // Sin texto contado/MSI: solo guía al checkout con OpenPay.
      hint.textContent = 'Usa «Finalizar compra» para pagar.';
    } else if (mode === 'contado') {
      hint.textContent =
        'Pago contado — usa «Finalizar compra». En checkout solo debe verse OpenPay.';
    } else if (mode === 'msi') {
      hint.textContent =
        'A meses sin intereses — usa «Finalizar compra». En checkout solo debe verse Mercado Pago.';
    } else {
      hint.textContent =
        'Tienes contado y MSI en el carrito. Quita una línea antes de pagar.';
      hint.style.color = '#b45309';
      checkout?.classList.add('armonia-pilot-hidden');
    }
  }

  function applyAll(mode) {
    document.querySelectorAll('.cart__ctas, .cart-drawer__ctas').forEach((ctas) => {
      applyRouteToCtas(ctas, mode);
    });
  }

  function bindCheckoutRouteButtons() {
    document
      .querySelectorAll('.cart__checkout-button, .cart-drawer__checkout-button')
      .forEach((btn) => {
        if (btn.dataset.armoniaRouteBound) return;
        btn.dataset.armoniaRouteBound = '1';
        btn.addEventListener(
          'click',
          (e) => {
            const mode =
              document.querySelector('.' + HINT_CLASS)?.dataset?.armoniaPilotMode || null;
            if (mode !== 'contado' && mode !== 'msi' && mode !== 'openpay') return;

            // Asegura atributo en el form + AJAX antes de que Shopify navegue a /checkout
            ensureRouteInputs(mode);
            e.preventDefault();
            e.stopPropagation();

            const go = async () => {
              try {
                const route = checkoutRouteForMode(mode);
                if (route && window.armoniaPilotCart?.setCheckoutRoute) {
                  await window.armoniaPilotCart.setCheckoutRoute(route);
                }
              } catch (_) {
                /* sigue al checkout igual */
              }
              const form =
                (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form'))) ||
                btn.closest('form');
              if (form) {
                ensureRouteInputs(mode);
                // form.submit() evita re-disparar este click handler
                const submitter = document.createElement('input');
                submitter.type = 'hidden';
                submitter.name = 'checkout';
                submitter.value = '';
                form.appendChild(submitter);
                HTMLFormElement.prototype.submit.call(form);
              } else {
                window.location.href = '/checkout';
              }
            };
            go();
          },
          true
        );
      });
  }

  async function sync() {
    try {
      if (window.armoniaPilotCart?.dedupePilotCart) {
        await window.armoniaPilotCart.dedupePilotCart();
      }
      const url =
        (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const mode = getPilotMode(cart.items);
      const route = mode && mode !== 'mixed' ? checkoutRouteForMode(mode) : '';
      if (route && window.armoniaPilotCart) {
        await window.armoniaPilotCart.setCheckoutRoute(route);
      }
      ensureRouteInputs(mode && mode !== 'mixed' ? mode : '');
      applyAll(mode);
      bindCheckoutRouteButtons();
    } catch (e) {
      /* noop */
    }
  }

  function boot() {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdateFinish, sync);
      subscribe(PUB_SUB_EVENTS.quantityUpdateFinish, sync);
    }
    document.addEventListener('shopify:section:load', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
